import { config } from 'src/config'

export const getBackofficeWorkflowUrl = (projectId: number, workflowId: number): string | null =>
  config.BACKOFFICE_URL ? `${config.BACKOFFICE_URL}/projects/${projectId}/workflows/${workflowId}` : null
